import * as cx from 'classnames';

export enum Method {
  SHOW = 'show',
  DEFERRED = 'deferred',
}

export interface NotifyProps {
  message: string;
  id: string;
  delay: number;
  cssClass: string;
  autoHide: boolean;
  method: Method;
}

class Notify {
  private props: NotifyProps;
  private el: HTMLDivElement = document.createElement('div');

  constructor(props: NotifyProps) {
    this.props = props;
    switch (this.props.method) {
      case Method.DEFERRED:
        this.deferred();
        return;
      case Method.SHOW:
        this.show();
        return;
    }
  }

  show = () => {
    this.el.className = cx('cpt-notification', 'show', this.props.cssClass);
    this.el.innerText = this.props.message;
    document.body.appendChild(this.el);
    if (this.props.autoHide) {
      setTimeout(this.hide, this.props.delay);
    }
  };

  hide = () => {
    try {
      document.body.removeChild(this.el);
    } catch (e) {
      // Doesn't matter if we fail to remove the node -- if it's not there, the message is already hidden.
    }
  };

  // This function just sets the cookies for the 'old' jQuery code to render.  We don't handle it.
  deferred = () => {
    document.cookie = `HRBnotify=${this.props.message}; path=/`;
    document.cookie = `HRBnotifyclass=${this.props.cssClass}; path=/`;
    return null;
  };
}

export default function notify(
  message: string,
  opts: Partial<NotifyProps>,
): Notify {
  const defaults: NotifyProps = {
    message,
    id: `notify-${Math.ceil(Math.random() * 1000000)}`,
    delay: 5000,
    cssClass: 'info',
    method: Method.SHOW,
    autoHide: true,
    ...opts,
  };
  return new Notify(defaults);
}



// WEBPACK FOOTER //
// ./app/javascript/utils/notify.tsx